// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.threeDModalStyle_dialogContent__X65Qr {
  display: flex;
  overflow-y: hidden;
}

.threeDModalStyle_tabContent__LoA6B {
  flex: 1 1;
}

.threeDModalStyle_model_div__zw9Ar {
  overflow: visible;
  height: 100%;
  width: 100%;
}

.threeDModalStyle_model_dimensions__ro5HN {
  font-size: 0.9em;
  color: #808080;
  padding: 0.9em 0em 1em 2em;
  position: absolute;
  bottom: 1em;
  left: 1em;
}

.threeDModalStyle_extra_info_div__WPeRO {
  display: flex;
  float: right;
  justify-content: space-between;
  flex: none;
  max-height: 100%;
}

.threeDModalStyle_productId__c2zg- {
  font-weight: bold;
  color: black;
  padding: 0px 2px 10px 5px;
}

.threeDModalStyle_email__IFupG {
  padding: 0px 2px 0px 5px;
}

.threeDModalStyle_product_created__PcbQt {
  padding: 0px 2px 10px 5px;
  font-size: 0.7rem;
}

.threeDModalStyle_image_div__5bwb9 {
  width: 12vw;
  height: 12vh;
  padding: 3px 10px 20px 5px;
}

.threeDModalStyle_typography_info_fileDownload__wR8u7 {
  display: flex;
  justify-content: center;
  padding: 15px 10px 10px 5px;
  font-size: 0.7rem;
}

.threeDModalStyle_typography_info_fileDownload__button__LDgML {
  display: flex;
  justify-content: center;
  width: 2vw;
  height: 2vh;
}

.threeDModalStyle_info_parameters__0ciIm {
  display: flex;
  flex-wrap: nowrap;
  justify-content: flex-start;
  padding: 0px 0px 0px 5px;
}

.threeDModalStyle_info_parameters__dimensions__T\\+SF1 {
  padding: 4px 0px 3px 5px;
  font-weight: bold;
  font-size: 1rem;
}

.threeDModalStyle_info_span__hC2cW {
  margin-right: 0.5em;
  margin-left: 0.5rem;
}

.threeDModalStyle_config_info__6JtUQ {
  padding: 1px 0px 0px 0px;
  font-size: 0.75rem;
}

.threeDModalStyle_config_info__font__0oZqf {
  font-size: 0.75rem;
}

.threeDModalStyle_typography_config__KVKY- {
  font-weight: bold;
  color: black;
  padding: 20px 0px 0px 5px;
}
.threeDModalStyle_typography_config__div__if6oF {
  display: flex;
  justify-content: flex-start;
}

.threeDModalStyle_typography_threads__DidEY {
  padding: 2px 0px 0px 2px;
  font-size: 0.75rem;
}

.threeDModalStyle_noFile_font__OUv\\+1 {
  font-weight: bold;
}

.threeDModalStyle_typography_pdf__BdQVl {
  display: flex;
  flex-wrap: nowrap;
  justify-content: flex-start;
  flex-direction: row;
  align-items: center;
  padding: 0px 10px 0px 2px;
  font-size: 0.75rem;
  width: 200px;
  height: 30px;
}

.threeDModalStyle_typography_pdf_name__uT4e5 {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.threeDModalStyle_typography_pdf__button__pc236 {
  display: flex;
  justify-content: center;
  width: 2vw;
  height: 2vh;
}

.threeDModalStyle_typography_comment__zatd7 {
  padding: 0px 0px 0px 2px;
  font-size: 0.75rem;
  font-weight: bold;
}

.threeDModalStyle_typography_comment__p__ltkZm {
  width: 230px;
  height: 50px;
  border: 1px solid rgb(209, 207, 207);
  border-radius: 5px;
  overflow-y: scroll;
  padding: 5px;
}

.threeDModalStyle_typography_est_stock__div__7MiSZ,
.threeDModalStyle_typography_est_work__div__I4YRs {
  display: flex;
  justify-content: flex-start;
}

.threeDModalStyle_typography_est_work__div__I4YRs {
  flex-direction: column;
  padding: 0px 0px 0px 1px;
  font-size: 0.75rem;
  width: 200px;
}

.threeDModalStyle_typography_est_stock__div_font__j0EVR,
.threeDModalStyle_typography_est_work__div_font__-kyWc {
  padding: 0px 0px 0px 1px;
  font-size: 0.75rem;
}

.threeDModalStyle_typography_est_work__div_font__-kyWc {
  justify-content: space-between;
}

.threeDModalStyle_sectionHeader__qX0wa {
  font-weight: bold;
  padding: 20px 0 0 0;
  margin: 0;
}

.threeDModalStyle_paragraph__\\+hvGD,
.threeDModalStyle_boldParagraph__kOS6\\+ {
  margin: 0;
}

.threeDModalStyle_boldParagraph__kOS6\\+ {
  font-weight: bold;
}

.threeDModalStyle_textTable__oQR-s {
  display: flex;
  justify-content: space-between;
  width: 220px;
}

.threeDModalStyle_textColumn__wvOJ1 {
  display: flex;
  flex-direction: column;
}

.threeDModalStyle_textRow__TUvF4 {
  display: flex;
  flex-direction: row;
  gap: 80px;
}
`, "",{"version":3,"sources":["webpack://./src/components/Modals/ModalStyles/threeDModalStyle.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,iBAAiB;EACjB,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,0BAA0B;EAC1B,kBAAkB;EAClB,WAAW;EACX,SAAS;AACX;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,8BAA8B;EAC9B,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,YAAY;EACZ,yBAAyB;AAC3B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,2BAA2B;EAC3B,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,UAAU;EACV,WAAW;AACb;;AAEA;EACE,aAAa;EACb,iBAAiB;EACjB,2BAA2B;EAC3B,wBAAwB;AAC1B;;AAEA;EACE,wBAAwB;EACxB,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,wBAAwB;EACxB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,YAAY;EACZ,yBAAyB;AAC3B;AACA;EACE,aAAa;EACb,2BAA2B;AAC7B;;AAEA;EACE,wBAAwB;EACxB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,iBAAiB;EACjB,2BAA2B;EAC3B,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,UAAU;EACV,WAAW;AACb;;AAEA;EACE,wBAAwB;EACxB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,oCAAoC;EACpC,kBAAkB;EAClB,kBAAkB;EAClB,YAAY;AACd;;AAEA;;EAEE,aAAa;EACb,2BAA2B;AAC7B;;AAEA;EACE,sBAAsB;EACtB,wBAAwB;EACxB,kBAAkB;EAClB,YAAY;AACd;;AAEA;;EAEE,wBAAwB;EACxB,kBAAkB;AACpB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,SAAS;AACX;;AAEA;;EAEE,SAAS;AACX;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX","sourcesContent":[".dialogContent {\n  display: flex;\n  overflow-y: hidden;\n}\n\n.tabContent {\n  flex: 1;\n}\n\n.model_div {\n  overflow: visible;\n  height: 100%;\n  width: 100%;\n}\n\n.model_dimensions {\n  font-size: 0.9em;\n  color: #808080;\n  padding: 0.9em 0em 1em 2em;\n  position: absolute;\n  bottom: 1em;\n  left: 1em;\n}\n\n.extra_info_div {\n  display: flex;\n  float: right;\n  justify-content: space-between;\n  flex: none;\n  max-height: 100%;\n}\n\n.productId {\n  font-weight: bold;\n  color: black;\n  padding: 0px 2px 10px 5px;\n}\n\n.email {\n  padding: 0px 2px 0px 5px;\n}\n\n.product_created {\n  padding: 0px 2px 10px 5px;\n  font-size: 0.7rem;\n}\n\n.image_div {\n  width: 12vw;\n  height: 12vh;\n  padding: 3px 10px 20px 5px;\n}\n\n.typography_info_fileDownload {\n  display: flex;\n  justify-content: center;\n  padding: 15px 10px 10px 5px;\n  font-size: 0.7rem;\n}\n\n.typography_info_fileDownload__button {\n  display: flex;\n  justify-content: center;\n  width: 2vw;\n  height: 2vh;\n}\n\n.info_parameters {\n  display: flex;\n  flex-wrap: nowrap;\n  justify-content: flex-start;\n  padding: 0px 0px 0px 5px;\n}\n\n.info_parameters__dimensions {\n  padding: 4px 0px 3px 5px;\n  font-weight: bold;\n  font-size: 1rem;\n}\n\n.info_span {\n  margin-right: 0.5em;\n  margin-left: 0.5rem;\n}\n\n.config_info {\n  padding: 1px 0px 0px 0px;\n  font-size: 0.75rem;\n}\n\n.config_info__font {\n  font-size: 0.75rem;\n}\n\n.typography_config {\n  font-weight: bold;\n  color: black;\n  padding: 20px 0px 0px 5px;\n}\n.typography_config__div {\n  display: flex;\n  justify-content: flex-start;\n}\n\n.typography_threads {\n  padding: 2px 0px 0px 2px;\n  font-size: 0.75rem;\n}\n\n.noFile_font {\n  font-weight: bold;\n}\n\n.typography_pdf {\n  display: flex;\n  flex-wrap: nowrap;\n  justify-content: flex-start;\n  flex-direction: row;\n  align-items: center;\n  padding: 0px 10px 0px 2px;\n  font-size: 0.75rem;\n  width: 200px;\n  height: 30px;\n}\n\n.typography_pdf_name {\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n}\n\n.typography_pdf__button {\n  display: flex;\n  justify-content: center;\n  width: 2vw;\n  height: 2vh;\n}\n\n.typography_comment {\n  padding: 0px 0px 0px 2px;\n  font-size: 0.75rem;\n  font-weight: bold;\n}\n\n.typography_comment__p {\n  width: 230px;\n  height: 50px;\n  border: 1px solid rgb(209, 207, 207);\n  border-radius: 5px;\n  overflow-y: scroll;\n  padding: 5px;\n}\n\n.typography_est_stock__div,\n.typography_est_work__div {\n  display: flex;\n  justify-content: flex-start;\n}\n\n.typography_est_work__div {\n  flex-direction: column;\n  padding: 0px 0px 0px 1px;\n  font-size: 0.75rem;\n  width: 200px;\n}\n\n.typography_est_stock__div_font,\n.typography_est_work__div_font {\n  padding: 0px 0px 0px 1px;\n  font-size: 0.75rem;\n}\n\n.typography_est_work__div_font {\n  justify-content: space-between;\n}\n\n.sectionHeader {\n  font-weight: bold;\n  padding: 20px 0 0 0;\n  margin: 0;\n}\n\n.paragraph,\n.boldParagraph {\n  margin: 0;\n}\n\n.boldParagraph {\n  font-weight: bold;\n}\n\n.textTable {\n  display: flex;\n  justify-content: space-between;\n  width: 220px;\n}\n\n.textColumn {\n  display: flex;\n  flex-direction: column;\n}\n\n.textRow {\n  display: flex;\n  flex-direction: row;\n  gap: 80px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"dialogContent": `threeDModalStyle_dialogContent__X65Qr`,
	"tabContent": `threeDModalStyle_tabContent__LoA6B`,
	"model_div": `threeDModalStyle_model_div__zw9Ar`,
	"model_dimensions": `threeDModalStyle_model_dimensions__ro5HN`,
	"extra_info_div": `threeDModalStyle_extra_info_div__WPeRO`,
	"productId": `threeDModalStyle_productId__c2zg-`,
	"email": `threeDModalStyle_email__IFupG`,
	"product_created": `threeDModalStyle_product_created__PcbQt`,
	"image_div": `threeDModalStyle_image_div__5bwb9`,
	"typography_info_fileDownload": `threeDModalStyle_typography_info_fileDownload__wR8u7`,
	"typography_info_fileDownload__button": `threeDModalStyle_typography_info_fileDownload__button__LDgML`,
	"info_parameters": `threeDModalStyle_info_parameters__0ciIm`,
	"info_parameters__dimensions": `threeDModalStyle_info_parameters__dimensions__T+SF1`,
	"info_span": `threeDModalStyle_info_span__hC2cW`,
	"config_info": `threeDModalStyle_config_info__6JtUQ`,
	"config_info__font": `threeDModalStyle_config_info__font__0oZqf`,
	"typography_config": `threeDModalStyle_typography_config__KVKY-`,
	"typography_config__div": `threeDModalStyle_typography_config__div__if6oF`,
	"typography_threads": `threeDModalStyle_typography_threads__DidEY`,
	"noFile_font": `threeDModalStyle_noFile_font__OUv+1`,
	"typography_pdf": `threeDModalStyle_typography_pdf__BdQVl`,
	"typography_pdf_name": `threeDModalStyle_typography_pdf_name__uT4e5`,
	"typography_pdf__button": `threeDModalStyle_typography_pdf__button__pc236`,
	"typography_comment": `threeDModalStyle_typography_comment__zatd7`,
	"typography_comment__p": `threeDModalStyle_typography_comment__p__ltkZm`,
	"typography_est_stock__div": `threeDModalStyle_typography_est_stock__div__7MiSZ`,
	"typography_est_work__div": `threeDModalStyle_typography_est_work__div__I4YRs`,
	"typography_est_stock__div_font": `threeDModalStyle_typography_est_stock__div_font__j0EVR`,
	"typography_est_work__div_font": `threeDModalStyle_typography_est_work__div_font__-kyWc`,
	"sectionHeader": `threeDModalStyle_sectionHeader__qX0wa`,
	"paragraph": `threeDModalStyle_paragraph__+hvGD`,
	"boldParagraph": `threeDModalStyle_boldParagraph__kOS6+`,
	"textTable": `threeDModalStyle_textTable__oQR-s`,
	"textColumn": `threeDModalStyle_textColumn__wvOJ1`,
	"textRow": `threeDModalStyle_textRow__TUvF4`
};
export default ___CSS_LOADER_EXPORT___;
